import { defineComponent as _defineComponent } from 'vue'
import {PropType, reactive, watch} from "vue";
  import OrderHistoryService from "@/service/OrderHistoryService";
  import {OrderChange} from "@/model/OrderHistory";
  import Order from "@/model/Order";
  import {t} from "@/mixin/mixins";
  import {useRoute} from "vue-router/composables";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OrderEditHistory',
  props: {
    order: {
      type: Object as PropType<Order>,
      default: () => null
    }
  },
  setup(__props) {

const props = __props

  

  const state = reactive({
    orderChanges: [] as OrderChange[],
    options: {
      page: 1,
      itemsPerPage: 10
    },
    serverItemsLength: -1,
    loading: false
  });

  const route = useRoute();

  // The changes come newest first from the server, which ignores any sort parameter, so the columns are not sortable.
  const headers = [
    {
      text: t("order.orderHistory.table.header.date"),
      align: "left",
      value: "changedAt",
      sortable: false
    },
    {
      text: t("order.orderHistory.table.header.employee"),
      align: "left",
      value: "changedBy",
      sortable: false
    }
  ];

  const loadOrderChanges = () => {
    const orderUuid = props.order?.uuid;
    if (!orderUuid) {
      return;
    }

    state.loading = true;
    OrderHistoryService.getOrderChanges(orderUuid, state.options.page - 1, state.options.itemsPerPage)
      .then(response => {
        state.orderChanges = response.data.content;
        state.serverItemsLength = response.data.page.totalElements;
      })
      .finally(() => state.loading = false);
  };

  // The order is loaded by the parent view, so its uuid only arrives after this tab is mounted.
  watch(() => [props.order?.uuid, state.options.page, state.options.itemsPerPage], () => {
    loadOrderChanges();
  }, {immediate: true});

  watch(() => route.path, (newPath) => {
    if (newPath.includes("editHistory")) {
      loadOrderChanges();
    }
  });


return { __sfc: true,props, state, route, headers, loadOrderChanges, t }
}

})